// Enum mappings (numeric <-> name) matching backend C# enums
export const CategoryEnum = {
  0: "None",
  1: "Main",
  2: "Movie",
  3: "Anime",
  4: "Talk",
  5: "Workshop",
  6: "Contest",
  7: "Special",
  9: "ProContest",
  10: "BookLaunch",
  11: "Quiz",
  12: "AuthorTalk",
};

// Localized (Default Culture) display values provided by user
export const CategoryDisplayNames = {
  None: "Bez kategórie",
  Main: "Hlavný program",
  Movie: "Film",
  Anime: "Anime",
  Talk: "Prednáška",
  Workshop: "Workshop",
  Contest: "Súťaž",
  Special: "Špeciálne",
  ProContest: "Pro súťaž",
  BookLaunch: "Krst",
  Quiz: "Kvíz",
  AuthorTalk: "Beseda",
};

export const EventTypeEnum = {
  0: "None",
  1: "Anime",
  2: "Japan",
  3: "Manga",
  4: "Games",
  5: "Horror",
  6: "Comics",
  7: "Korea",
  8: "Larp",
  9: "SciFi",
  10: "Ecchi",
  11: "Fantasy",
  12: "PopCulture",
  13: "Cosplay",
};

export const CategoryNameToValue = Object.fromEntries(
  Object.entries(CategoryEnum).map(([k, v]) => [v, Number(k)])
);
export const EventTypeNameToValue = Object.fromEntries(
  Object.entries(EventTypeEnum).map(([k, v]) => [v, Number(k)])
);
